import axios from "axios";
import { json, replace } from "react-router-dom";

import { validateDocument } from "../../api/validate";

export async function loader({ params }): Promise<Response> {
  try {
    const { id } = params as { id: string };

    const { data: documentSignatures } = await validateDocument(id);
    if (documentSignatures.hash !== id) {
      return replace(`/validate/${documentSignatures.hash}`);
    }
    return json(documentSignatures, { status: 200 });
  } catch (e) {
    if (axios.isAxiosError(e)) {
      // eslint-disable-next-line @typescript-eslint/no-throw-literal -- expected
      throw json(e.response, { status: e.response?.status || 500 });
    }
    // eslint-disable-next-line @typescript-eslint/no-throw-literal -- expected
    throw json(e, { status: 500 });
  }
}
